/* eslint-disable import/prefer-default-export */
import * as React from 'react'
import * as styles from './counter.styl'
import cx from 'classnames'
import { formatAlertValue, alertFormat } from '@src/utils/format'

export enum Layout {
  Marker,
  Default
}

export interface CounterProps {
  className?: string
  count: number
  layout: Layout
  color: 'red' | 'orange' | 'yellow'
}

export const Counter: React.FC<CounterProps> = ({
  className,
  layout = Layout.Default,
  color,
  count,
  children
}: React.PropsWithChildren<CounterProps>) => (
  <div
    className={cx(styles.counter, className, styles[color], {
      [styles.marker]: layout === Layout.Marker
    })}
  >
    {layout === Layout.Marker
      ? null
      : formatAlertValue(count, alertFormat) || children}
  </div>
)
